export default {
  'settings': {
    'endpointsSectionTitle': 'Points de terminaison de service (URI ou URL complète)',
    'language': 'Langue',
    'appLocale': 'Paramètres régionaux de l\'app',
    'unit': 'Unité',
    'areaUnit': 'Unité de surface',
    'saveToLocalStorage': 'Enregistrer dans mon navigateur',
    'routeInstructions': 'Instructions de routage',
    'alternativeIsochroneColors': 'Couleurs isochrones alternatives',
    'distanceMarkers': 'Marqueurs de distance',
    'elevationProfile': 'Profil d\'élévation',
    'mapSettings': 'Vue de la carte et infos supplémentaires',
    'defaultMapSettingsRestored': 'Paramètres de carte par défaut restaurés et enregistrés',
    'endpointsTitle': {
      'directions': 'Itinéraire',
      'isochrones': 'Isochrones',
      'geocodeSearch': 'Recherche de géocodage',
      'autocomplete': 'Saisie semi-automatique du géocodage',
      'pois': 'POIs',
      'reverseGeocode': 'Geocode inverse'
    },
    'apiKey': 'Clé API',
    'customApiKey': 'Clé API personnalisée',
    'apiBaseUrl': 'URL de base de l\'API',
    'invalidSettingsValue': 'Valeur(s) de paramètre non valide(s). Veuillez vérifier les champs ou restaurer les valeurs par défaut',
    'restoreDefaults': 'Restaurer les valeurs par défaut',
    'advanced': 'Avancée',
    'mapSettingsSaved': 'Paramètres de la carte enregistrés',
    'alwaysFitBounds': 'Ajustez toujours les limites lorsque l\'itinéraire change',
    'routeExtraInfo': 'Informations supplémentaires sur l\'itinéraire',
    'mapViewOptions': 'Options d\'affichage de la carte',
    'advancedSettingsWarning': 'Ne modifiez pas les paramètres ci-dessous si vous ne savez pas ce que vous faites!',
    'customOverlayerTileProviderUrl': 'URL du fournisseur de superposition personnalisé',
    'customTileProviderUrl': 'URL du fournisseur de tuiles personnalisées',
    'defaultTilesProvider': 'Fournisseur de tuiles par défaut',
    'customTileProviderUrlHint': 'https://domain.tld/chemin/{z}/{x}/{y}.ext?cleOptionnelle=valeur',
    'prioritizeSearchingForNearbyPlaces': 'Prioriser la recherche de lieux à proximité',
    'defaultProfile': 'Profil par défaut',
    'compressDataUrlSegment': 'Compresser le segment d\'URL après /data/',
    'autoFitHighlightedBounds': 'Ajuster automatiquement les limites en surbrillance',
    'reloadToApplyLanguageChangeTitle': 'Il est nécessaire de recharger l\'application',
    'reloadToApplyLanguageChangeText': 'Afin d\'appliquer pleinement le changement de langue, il est nécessaire de recharger l\'application. Recharger maintenant?',
    'resetShownOnceTooltips': 'Afficher à nouveau les info-bulles lors du chargement de l\'application',
    'convertStopAfterRouteEndingToDestination': 'Convertir l\'arrêt après la fin de l\'itinéraire vers la destination',
    'skipAllSegments': 'itinéraire droit pour tous les segments',
    'useStopOptimization': 'Optimiser l\'itinéraire lorsqu\'un arrêt est créé par glisser / sauter'

  }
}
